import styled, { css } from 'styled-components';

export const StyledBundleLayout = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;

  /* BfS 4.1.2 mobile-friendly: stack dọc thay vì ép cột main còn ~95px */
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledBundleMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledBundleAside = styled.div`
  width: 264px;
  flex-shrink: 0;
  position: sticky;
  top: 20px;

  /* mobile: summary card full-width dưới cột main, bỏ sticky khi đã stack */
  @media (max-width: 768px) {
    width: 100%;
    position: static;
  }
`;

export const StyledPlanGrid = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const StyledPlanLabel = styled.label`
  flex: 1;
  min-width: 90px;
  display: block;
  cursor: pointer;
`;

export const StyledPlanCard = styled.div<{ $active: boolean }>`
  border: 1.5px solid #e1e3e5;
  border-radius: 8px;
  padding: 10px 12px;
  transition: border-color 0.15s, background 0.15s;
  display: flex;
  flex-direction: column;
  gap: 3px;
  height: 100%;

  ${({ $active }) =>
    $active &&
    css`
      border-color: #008060;
      background: #f6fef9;
    `}

  &:hover {
    border-color: #b5b5b5;
  }
`;

export const StyledCodeBox = styled.div<{ $locked?: boolean }>`
  font-family: 'Courier New', monospace;
  background: #f4f6f8;
  border: 1px dashed #b5b5b5;
  border-radius: 6px;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: ${({ $locked }) => ($locked ? '#c9cccf' : '#1a1a2e')};
  flex: 1;
  ${({ $locked }) =>
    $locked &&
    css`
      filter: blur(3px);
      user-select: none;
    `}
`;

export const StyledSavingsBox = styled.div`
  background: #e3f5eb;
  border: 1px solid #95c9a8;
  border-radius: 8px;
  padding: 9px 12px;
`;

export const StyledActionRow = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #e1e3e5;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #1a1a2e;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    background: #fafbfb;
    border-color: #c9cccf;
  }
`;

export const StyledSummaryAppRow = styled.div`
  display: grid;
  grid-template-columns: 22px 1fr auto;
  grid-template-rows: auto auto;
  column-gap: 8px;
  row-gap: 2px;
  align-items: center;
`;

export const StyledSummaryChip = styled.div`
  grid-column: 1;
  grid-row: 1 / 3;
  align-self: center;
`;

export const StyledSummaryName = styled.div`
  grid-column: 2;
  grid-row: 1;
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
`;

export const StyledSummaryTier = styled.div`
  grid-column: 2;
  grid-row: 2;
  font-size: 12px;
  color: #8c9196;
`;

export const StyledSummaryPrice = styled.div<{ $discounted: boolean }>`
  grid-column: 3;
  grid-row: 1;
  text-align: right;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  color: ${({ $discounted }) => ($discounted ? '#008060' : '#1a1a2e')};
`;

export const StyledSummaryOrigPrice = styled.div`
  grid-column: 3;
  grid-row: 2;
  text-align: right;
  white-space: nowrap;
  font-size: 11px;
  text-decoration: line-through;
  color: #8c9196;
`;

export const StyledStrike = styled.span`
  text-decoration: line-through;
  color: #8c9196;
  font-size: 12px;
`;

export const StyledStepNum = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #f1f1f1;
  border: 1px solid #dde0e3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #6d7175;
  flex-shrink: 0;
`;

export const StyledAppToggle = styled.label`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;

  input {
    accent-color: #008060;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
`;
